import DOMPurify from 'dompurify';
import { isValidNumber } from 'libphonenumber-js';
import { FORBIDDEN_PHRASES } from '../utils/common-literals';

export const ONLY_DIGIT_REGEX = /^[\d+]*$/;

export function isSafeUserInput(userInput) {
  return DOMPurify.sanitize(userInput, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }) === userInput;
}

export function textValidator(value) {
  return !!(value && value.trim()) && isSafeUserInput(value);
}

export function emailValidator(value) {
  const regex = /^\w+(?:[_\.+-]\w+){0,63}\@(([a-zA-Z0-9-])+\.){1,10}([a-zA-Z0-9]{2,8})$/; //eslint-disable-line
  return value?.length >= 6 && value?.length <= 254 && regex.test(value);
}

export function phoneNumberValidator(nationalNumber, countryCode) {
  if (nationalNumber && countryCode) {
    let countryCodeRef = countryCode;
    if (!countryCode.startsWith('+')) {
      countryCodeRef = `+${countryCode}`;
    }
    return isValidNumber(`${countryCodeRef}${nationalNumber}`);
  }
  return false;
}

export function passwordValidator(value) {
  return /[a-zA-Z]/.test(value) && /\d/.test(value) && value.length >= 8 && value.length <= 64;
}

export const containsForbiddenWords = (input = '') => {
  const lowerCaseInput = input.toLowerCase();
  return FORBIDDEN_PHRASES.findIndex(word => lowerCaseInput.includes(word)) !== -1;
};
